import React, { useEffect, useState } from "react";
import {
  email,
  Edit,
  SimpleForm,
  TextInput,
  required,
  BooleanInput,
  ReferenceField,
  useNotify,
  useRedirect,
  useRecordContext,
  Button,
  SaveButton,
  Toolbar,
  ReferenceInput,
  useDataProvider,
} from "react-admin";
import {
  Box,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@material-ui/core";
import PasswordChecklist from "react-password-checklist";
import { db, auth } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { updatePassword } from "firebase/auth";
import { Alert } from "react-bootstrap";

const ProfileEdit = ({ userId, userDetails, clientData }) => {
  const redirect = useRedirect();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState(
    clientData ? clientData.companyName : "",
  );
  const [companyRegNo, setCompanyRegNo] = useState(
    clientData ? clientData.companyRegNumber : "",
  );
  const [companyAddress, setCompanyAddress] = useState(
    clientData ? clientData.companyAddress : "",
  );
  const [merchantCode, setMerchantCode] = useState(
    clientData ? clientData.paymentMethods.ipay88.merchantCode : "M27182_S0004",
  );
  const [merchantKey, setMerchantKey] = useState(
    clientData ? clientData.paymentMethods.ipay88.merchantKey : "TAJuYMbqNm",
  );
  const [paymentEmail, setPaymentEmail] = useState(
    clientData
      ? clientData.paymentMethods.ipay88.email
      : "support@vechnology.com.my",
  );
  const [paymentNumber, setPaymentNumber] = useState(
    clientData ? clientData.paymentMethods.ipay88.phoneNumber : "0333100103",
  );
  const [paymentUsername, setPaymentUsername] = useState(
    clientData ? clientData.paymentMethods.ipay88.username : "vechnology",
  );
  const [paymentIsActive, setPaymentIsActive] = useState(
    clientData ? clientData.paymentMethods.ipay88.isActive : false,
  );
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const valid =
      hasMinLength &&
      hasCapital &&
      hasNumber &&
      hasAllowedSpecial &&
      hasNoSpaces &&
      passwordsMatch;
    setIsPasswordValid(valid);
  }, [password, passwordAgain]);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    console.log(newPassword, "mana New Password saya di mana");
    setPassword(newPassword);
  };

  const handlePasswordAgainChange = (e) => {
    const newPasswordAgain = e.target.value;
    setPasswordAgain(newPasswordAgain);
  };

  const passwordValidation = (e) => {
    if (!isPasswordValid) {
      return "Please create a password that fulfills the below criteria.";
    } else {
      return undefined;
    }
  };

  const passwordAgainValidation = () => {
    if (password !== passwordAgain)
      return "Confirm password must match with the password.";
    else return undefined;
  };

  const validatePassword = [
    required("Please enter a secure password."),
    passwordValidation,
  ];
  const validatePasswordAgain = [
    required("Please re-enter the password"),
    passwordAgainValidation,
  ];

  const handleEdit = async (updatedRecord) => {
    try {
      const currentUser = auth.currentUser;
      await updatePassword(currentUser, updatedRecord.currentPassword);
      //update users collection
      const userDocRef = doc(db, "users", userId);

      const userUpdates = {
        firstName: updatedRecord.firstName,
        lastName: updatedRecord.lastName,
        email: updatedRecord.email,
      };

      if (userDetails?.isOwner === true) {
        userUpdates["client.companyName"] = updatedRecord.client.companyName;
        userUpdates["client.id"] = updatedRecord.clientId;

        //update clients collection
        const clientDocRef = doc(db, "clients", updatedRecord.clientId);

        await updateDoc(clientDocRef, {
          id: updatedRecord.clientId,
          companyName: updatedRecord.client.companyName,
          companyRegNumber: updatedRecord.companyRegNumber,
          companyAddress: updatedRecord.companyAddress,
          // "paymentMethods.ipay88.merchantCode":
          //   updatedRecord.paymentMethods.ipay88.merchantCode,
          // "paymentMethods.ipay88.merchantKey":
          //   updatedRecord.paymentMethods.ipay88.merchantKey,
          // "paymentMethods.ipay88.email":
          //   updatedRecord.paymentMethods.ipay88.email,
          // "paymentMethods.ipay88.phoneNumber":
          //   updatedRecord.paymentMethods.ipay88.phoneNumber,
          // "paymentMethods.ipay88.username":
          //   updatedRecord.paymentMethods.ipay88.username,
          // "paymentMethods.ipay88.isActive":
          //   updatedRecord.paymentMethods.ipay88.isActive,
        });
      }
      await updateDoc(userDocRef, userUpdates);

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      redirect("/profile");
    } catch (err) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    }
  };

  const SaveButtons = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton label="Save" />
      </Toolbar>
    );
  };

  const allowedSpecialChars = /[!@#$%^&*()_+=?.]/;
  const hasMinLength = password.length >= 8;
  const hasCapital = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasAllowedSpecial = allowedSpecialChars.test(password);
  const hasNoSpaces = !/\s/.test(password);
  const passwordsMatch = password === passwordAgain;

  const checkIcon = (condition) => (condition ? "✅" : "❌");
  const checkStyle = (condition) => ({
    color: "black",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "1rem",
  });
  return (
    <>
      <div style={{ width: "90%" }}>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => setShowError(false)}
            alert-dismissible
            fade
            show
          >
            Record not updated!
          </Alert>
        )}
        {showSuccess && (
          <Alert
            variant="success"
            onClose={() => setShowSuccess(false)}
            alert-dismissible
            fade
            show
          >
            Record updated successfully!
          </Alert>
        )}
        {userId && (
          <SimpleForm
            toolbar={<SaveButtons />}
            component="form"
            onSubmit={handleEdit}
            noValidate
          >
            <CardHeader title="Profile Details" />
            <CardContent className="text-input-width">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextInput
                    fullWidth
                    label="First name"
                    source="firstName"
                    validate={required("Please enter a first name.")}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                    defaultValue={userDetails?.firstName}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextInput
                    fullWidth
                    label="Last name"
                    source="lastName"
                    validate={required("Please enter a last name.")}
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                    defaultValue={userDetails?.lastName}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextInput
                    label="Email Address"
                    source="email"
                    type="email"
                    validate={[
                      required("Please enter a valid email."),
                      email("Please enter a valid email."),
                    ]}
                    disabled
                    fullWidth
                    defaultValue={userDetails?.email}
                  />
                </Grid>
              </Grid>
            </CardContent>

            <CardHeader title="Change password" />
            <CardContent className="text-input-width">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextInput
                    label="Password"
                    source="currentPassword"
                    type="password"
                    onChange={(e) => handlePasswordChange(e)}
                    validate={validatePassword}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextInput
                    label="Confirm Password"
                    source="password"
                    type="password"
                    onChange={(e) => handlePasswordAgainChange(e)}
                    validate={validatePasswordAgain}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Typography style={checkStyle(hasMinLength)}>
                    {checkIcon(hasMinLength)} Password has at least 8
                    characters.
                  </Typography>

                  <Typography style={checkStyle(hasCapital)}>
                    {checkIcon(hasCapital)} Password has a capital letter.
                  </Typography>

                  <Typography style={checkStyle(hasNumber)}>
                    {checkIcon(hasNumber)} Password has a number.
                  </Typography>

                  <Typography style={checkStyle(hasAllowedSpecial)}>
                    {checkIcon(hasAllowedSpecial)} Allowed special characters (!
                    @ # $ % ^ & * ( ) _ + = ? .)
                  </Typography>

                  <Typography style={checkStyle(passwordsMatch)}>
                    {checkIcon(passwordsMatch)} Passwords match.
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
            {userDetails?.isOwner == true && (
              <>
                <CardHeader title="Company Details" />
                <CardContent className="text-input-width">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextInput
                        label="Company Name"
                        source="client.companyName"
                        fullWidth
                        defaultValue={clientData?.companyName}
                        validate={required("Please enter a company name")}
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextInput
                        label="Company Registration No."
                        source="companyRegNumber"
                        fullWidth
                        defaultValue={clientData?.companyRegNumber}
                        onChange={(e) => {
                          setCompanyRegNo(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <TextInput
                        label="Company Address"
                        fullWidth
                        source="companyAddress"
                        defaultValue={clientData?.companyAddress}
                        onChange={(e) => {
                          setCompanyAddress(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <TextInput
                        label="Client Id"
                        source="clientId"
                        defaultValue={clientData?.id}
                        disabled
                        fullWidth
                        style={{ display: "none" }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>

                <CardHeader title="Payment Settings" />
                <CardContent className="text-input-width">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextInput
                        label="Merchant Code"
                        fullWidth
                        source="paymentMethods.ipay88.merchantCode"
                        defaultValue={
                          clientData?.paymentMethods?.ipay88?.merchantCode
                        }
                        // onChange={(e) => {
                        //   setMerchantCode(e.target.value);
                        // }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextInput
                        label="Merchant Key"
                        fullWidth
                        source="paymentMethods.ipay88.merchantKey"
                        defaultValue={
                          clientData?.paymentMethods?.ipay88?.merchantKey
                        }
                        // onChange={(e) => {
                        //   setMerchantKey(e.target.value);
                        // }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextInput
                        label="Email"
                        fullWidth
                        source="paymentMethods.ipay88.email"
                        defaultValue={clientData?.paymentMethods?.ipay88?.email}
                        // onChange={(e) => {
                        //   setPaymentEmail(e.target.value);
                        // }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextInput
                        label="Phone Number"
                        fullWidth
                        source="paymentMethods.ipay88.phoneNumber"
                        defaultValue={
                          clientData?.paymentMethods?.ipay88?.phoneNumber
                        }
                        // onChange={(e) => {
                        //   setPaymentNumber(e.target.value);
                        // }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextInput
                        label="Username"
                        fullWidth
                        source="paymentMethods.ipay88.username"
                        defaultValue={
                          clientData?.paymentMethods?.ipay88?.username
                        }
                        // onChange={(e) => {
                        //   setPaymentUsername(e.target.value);
                        // }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      {/* <ReferenceField source="client.id" reference="clients" label="Active">
                                                    <BooleanInput label="Active" source="paymentMethods.ipay88.isActive" fullWidth />
                                                </ReferenceField> */}
                      <BooleanInput
                        label="isActive"
                        fullWidth
                        source="paymentMethods.ipay88.isActive"
                        defaultValue={
                          clientData?.paymentMethods?.ipay88?.isActive
                        }
                        // onChange={(e) => {
                        //   setPaymentIsActive(e.target.value);
                        // }}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </>
            )}
          </SimpleForm>
        )}
      </div>
    </>
  );
};

export default ProfileEdit;
